import { Center } from 'native-base'

import { Loader as UILoader } from '@consumer/ui'

/**
 * Full-screen centered spinner shown during page-level data loading.
 *
 * The spinner itself is the shared `@consumer/ui` Loader; this shim only owns
 * CWA's page-level positioning (`50vh` has no react-native equivalent).
 */
export default function Loader() {
  return (
    <Center flex={1} minHeight="50vh" margin="auto" px="3">
      <UILoader />
    </Center>
  )
}
